<template>
  <div class="app-change-password-wrapper">
    <ChangePasswordEdit
      ref="ChangePasswordEdit"
      :old-password.sync="oldPassword"
      :new-password.sync="newPassword"
      :invalid.sync="invalid"
    >
      <template v-for="slot in possibleChildSlotsFor('Edit')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangePasswordEdit>

    <Stepper
      :show-prev="false"
      :loading-next="loading"
      :disabled-next="invalid"
      @next="savePassword"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>
<script>
import ChangePasswordEdit from '@/components/process/generic/Password/ChangePassword/Edit.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../../mixins/slotProxy'
import Stepper from '../../../../../generic/Stepper.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ChangePasswordWrapper',
  components: { Stepper, ChangePasswordEdit },
  data () {
    return {
      oldPassword: null,
      newPassword: null,
      invalid: true,
      loading: false
    }
  },
  methods: {
    ...mapActions('changePassword', [
      'changePassword'
    ]),
    async reset () {
      await this.$refs.ChangePasswordEdit.reset()
    },
    savePassword () {
      this.loading = true
      this.changePassword({ changePasswordData: { oldPassword: this.oldPassword, password: this.newPassword } })
        .then(() => {
          this.loading = false
          this.reset()
        }, () => {
          this.loading = false
          this.reset()
        })
    }
  },
  mixins: [
    transaction('changePassword'),
    slotProxy()
  ]
}
</script>
